// #33 Count: a number on the neutral tint, beside a section title, a tab or a nav item. `label` names what is counted
// for assistive technology when the context does not.

import { cx } from "../lib/cx";
import { VisuallyHidden } from "../lib/VisuallyHidden";

export interface CountProps {
  n: number;
  /** What is counted, read after the number (a label). */
  label?: string | undefined;
  className?: string | undefined;
}

export function Count({ n, label, className }: CountProps) {
  return (
    <span className={cx("mc-count", className)}>
      {n}
      {label ? <VisuallyHidden>{label}</VisuallyHidden> : null}
    </span>
  );
}
